module.exports = __webpack_public_path__ + "static/media/cloud_watch4.633c8ac6.png";